import React, { useState,useEffect,useCallback } from "react";
import { Container, TextField, MenuItem, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Typography,Grid,Pagination } from "@mui/material";
import axios from "axios";
import BASE_URL from "../config";
const PromotePage = () => {
   const [courses, setCourses] = useState([]);
     const [academicYears, setAcademicYears] = useState([]);
     const [classes, setClasses] = useState([]);
     const [selectedCourse, setSelectedCourse] = useState("");
     const [selectedYear, setSelectedYear] = useState("");
     const [selectedClass, setSelectedClass] = useState("");
      const [searchText, setSearchText] = useState("");
    const [students, setStudents] = useState([]);
    const [page, setPage] = useState(1);
      const [totalPages, setTotalPages] = useState(1);
      const [selectedStudents, setSelectedStudents] = useState([]);
const [selectAll, setSelectAll] = useState(false);
// Fetch courses
  useEffect(() => {
    axios.get(`${BASE_URL}/api/coursesa`).then((res) => setCourses(res.data));
  }, []);
  // Fetch academic years and classes when course changes
  useEffect(() => {
    if (selectedCourse) {
      axios.get(`${BASE_URL}/api/academicYears/${selectedCourse}`).then((res) => setAcademicYears(res.data));
      //axios.get(`${BASE_URL}/api/classes/${selectedCourse}`).then((res) => setClasses(res.data));
      axios.get(`${BASE_URL}/api/classes?course=${selectedCourse}`).then((res) => setClasses(res.data));
    } else {
      setAcademicYears([]);
      setClasses([]);
    }
  }, [selectedCourse]);
  // Fetch students when search filters change
   useEffect(() => {
     if (selectedCourse || selectedYear || selectedClass || searchText) {
       handleSearch();
     }
   }, [page]); // Runs when page changes
    const handleSearch =  () => {
            if (!selectedCourse || !selectedYear || !selectedClass) {
                alert("Please select Course, Academic Year, and Class before searching.");
                return;
              }
        try {
          console.log(selectedCourse,selectedYear,selectedClass)
            axios
                  .get(
                    `${BASE_URL}/api/students?courseId=${selectedCourse}&yearId=${selectedYear}&classId=${selectedClass}&search=${searchText}&page=${page}`
                  )
                  .then((res) => {
                    setStudents(res.data.students);
                    setTotalPages(res.data.totalPages);
                  })
                  .catch((err) => console.error("Error fetching students:", err));
        } catch (error) {
            console.error("Error fetching students", error);
        }
    };
    const handlePromoteAll = async () => {
  if (selectedStudents.length === 0) {
    alert("Please select students to promote!");
    return;
  }
  try {
    const adminName = sessionStorage.getItem("adminName");
    // OPTIONAL: show fee info (but don't block)
    const response = await fetch(`${BASE_URL}/api/checkFeeBalance`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ studentIDs: selectedStudents }),
    });
    const result = await response.json();
    if (result.feeDetails?.length > 0) {
      const studentsWithBalance = result.feeDetails.filter(
        s => Number(s.balance) > 0
      );
      if (studentsWithBalance.length > 0) {
        let msg = "These students have pending fees:\n";
        studentsWithBalance.forEach(s => {
          msg += `${s.StudentName}: ₹${s.balance}\n`;
        });
        alert(msg); // just info, NOT blocking
      }
    }
    // ✅ Promote ALL selected students
    const promoteResponse = await fetch(`${BASE_URL}/api/promoteStudents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        studentIDs: selectedStudents,
        adminName,
      }),
    });
    const promoteResult = await promoteResponse.json();
    if (promoteResult.success) {
      alert("Students promoted successfully!");
      setSelectedStudents([]);
      setSelectAll(false);
      handleSearch(); // refresh list
    } else {
      alert("Error promoting students");
    }
  } catch (error) {
    console.error(error);
    alert("Error during promotion");
  }
};
    const handleSelectAll = (e) => {
  const checked = e.target.checked;
  setSelectAll(checked);
  if (checked) {
    setSelectedStudents(students.map(s => s.StudentID));
  } else {
    setSelectedStudents([]);
  }
};
const handleSelectOne = (id) => {
  setSelectedStudents(prev =>
    prev.includes(id)
      ? prev.filter(sid => sid !== id)
      : [...prev, id]
  );
};
    return (
        <Container maxWidth="lg">
              <Typography variant="h4" sx={{ marginBottom: 2, textAlign: "center", fontWeight: "bold", color: "#1976d2" }}>
              Promote
             </Typography>
            {/* Filters Section */}
                 <Grid container spacing={2}>
                   <Grid item xs={12} sm={4}>
                     <TextField
                       select
                       label="Course"
                       value={selectedCourse}
                       onChange={(e) => setSelectedCourse(e.target.value)}
                       fullWidth
                     >
                       {courses.map((course) => (
                         <MenuItem key={course.CourseID} value={course.CourseID}>
                           {course.CourseName}
                         </MenuItem>
                       ))}
                     </TextField>
                   </Grid>
                   <Grid item xs={12} sm={4}>
                     <TextField
                       select
                       label="Academic Year"
                       value={selectedYear}
                       onChange={(e) => setSelectedYear(e.target.value)}
                       fullWidth
                       disabled={!selectedCourse}
                     >
                       {academicYears.map((year) => (
                         <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                           {year.AcademicYearName}
                         </MenuItem>
                       ))}
                     </TextField>
                   </Grid>
                   <Grid item xs={12} sm={4}>
                     <TextField
                       select
                       label="Class"
                       value={selectedClass}
                       onChange={(e) => setSelectedClass(e.target.value)}
                       fullWidth
                       disabled={!selectedCourse}
                     >
                       {classes.map((cls) => (
                         <MenuItem key={cls.id} value={cls.id}>
                           {cls.name}
                         </MenuItem>
                       ))}
                     </TextField>
                   </Grid>
                 </Grid>
                   <Grid container spacing={2} sx={{ marginTop: 2 }}>
                         <Grid item xs={9}>
                           <TextField label="Search Student" value={searchText} onChange={(e) => setSearchText(e.target.value)} fullWidth />
                         </Grid>
                         <Grid item xs={3}>
            <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button> </Grid>
                  </Grid>
            {students.length > 0 && (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                             <TableCell>
      <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
    </TableCell>
                                <TableCell>Student Name</TableCell>
                                <TableCell>Student ID</TableCell>
                                 <TableCell>Course</TableCell>
    <TableCell>Year</TableCell>
    <TableCell>Class</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {students.map((student) => (
                                <TableRow key={student.StudentID}>
                                 <TableCell>
        <input
          type="checkbox"
          checked={selectedStudents.includes(student.StudentID)}
          onChange={() => handleSelectOne(student.StudentID)}
        />
      </TableCell>
                                    <TableCell>{student.StudentName}</TableCell>
                                    <TableCell>{student.StudentID}</TableCell>
                                    <TableCell>{student.CourseName}</TableCell>
                                <TableCell>{student.AcademicYearName}</TableCell>
                                <TableCell>{student.ClassName}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>       
            )}
             {/* Promote All Button */}
        {students.length > 0 && (
            <Grid container justifyContent="center" sx={{ marginTop: 2 }}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handlePromoteAll}
                >
                    Promote All
                </Button>
            </Grid>
        )}
             {/* Pagination */}
             <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => setPage(value)}
                        sx={{ marginTop: 2, display: "flex", justifyContent: "center" }}
                      />
        </Container>
    );
};
export default PromotePage;